import { AssignChannelsV2Query, AssignChannelsV2QueryVariables, SortEnum } from '@/types/generated/graphql';
import { useState } from 'react';
import { useCursorPagination } from '@shared/hooks/use-cursor-pagination';
import { CURSOR_ASSIGN_CHANNELS_V2 } from '@/graphql/cursor.graphql';
import { Prettify } from '@/types/app.types';
import { UseAssignChannelReturn } from '../channel.types';

export function useAssignChannels(): Prettify<UseAssignChannelReturn> {
  const [filter, setFilter] = useState({
    query: '',
    limit: 4,
    order: 'isDefault',
    sort: SortEnum.DESC,
  });

  const { data, initialLoading, hasNextPage } = useCursorPagination<
    AssignChannelsV2Query,
    AssignChannelsV2QueryVariables
  >({
    schema: CURSOR_ASSIGN_CHANNELS_V2,
    responseDataKey: 'assignChannelsV2',
    variables: filter,
  });

  return {
    data,
    setFilter,
    hasNextPage,
    initialLoading,
  };
}
